<template>
  <div>
    <div class="page-title">Edit Notification</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Notification"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.notifications.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Notification.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.Notification.update(this.form);
      this.$router.push("/widgets/notifications");
    },
  },
};
</script>

<style></style>
